// @flow

import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const addMutation = graphql`
	mutation ConfigurableBlockAddMutation($input: ConfigurableBlockAddInput!) {
		ConfigurableBlockAdd(input: $input) {
			error
			edge {
				node {
					id
				}
			}
		}
	}
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
	commitMutation(environment, {
		mutation: addMutation,
		variables: {
			input: params,
		},
		onCompleted: response => {
			const {error, edge} = response.ConfigurableBlockAdd;
			if (error) {
				callback(error, null);
				return;
			}

			callback(null, edge);
		},
		onError: error => {
			console.log('error mutating');
			console.log(error);
			callback(error, null);
		},
	});
}



// WEBPACK FOOTER //
// src/components/configurable-blocks/mutations/ConfigurableBlockAdd.js